// Known crawlers and automation never become analytics or ad events.
//
// The same user-agent list lives in three places that cannot import each
// other, pinned equal by botDetection.test.ts:
//   src/lib/botDetection.ts                   (this file: PostHog init and capture)
//   index.html                                (inline tracker loader: GTM, and
//                                              through it the Meta pixel and GA4)
//   supabase/functions/_shared/bots.ts        (edge: desktop-download, meta-capi-download)
// Prerendering is untouched: vite-prerender-plugin renders in plain Node with
// no navigator, where this answers false, and the static HTML it writes still
// carries the loader for real browsers.

export const BOT_UA_SOURCE = 'facebookexternalhit|meta-externalagent|meta-externalfetcher|Facebot|AdsBot-Google|Googlebot|Google-InspectionTool|bingbot|GPTBot|ClaudeBot|Claude-User|PerplexityBot|OAI-SearchBot|HeadlessChrome|Lighthouse|Chrome-Lighthouse|Slackbot|Twitterbot|LinkedInBot|Applebot|DuckDuckBot|YandexBot|Baiduspider|Bytespider|CCBot|Amazonbot|PetalBot|SemrushBot|AhrefsBot|MJ12bot|Discordbot|WhatsApp|TelegramBot|Pinterestbot|PTST|Prerender|Screaming Frog';

export const BOT_UA_PATTERN = new RegExp(BOT_UA_SOURCE, 'i');

export interface VisitorSignals {
  userAgent?: string | null;
  /** navigator.webdriver: true under Selenium, Playwright, Puppeteer and friends. */
  webdriver?: boolean | null;
}

/** True for a known crawler UA or an automated browser. An absent UA is not
 *  a bot: real clients sometimes send none and would otherwise go dark. */
export function isBotVisitor(signals: VisitorSignals | null | undefined): boolean {
  if (!signals) return false;
  if (signals.webdriver === true) return true;
  const ua = signals.userAgent;
  return typeof ua === 'string' && ua.length > 0 && BOT_UA_PATTERN.test(ua);
}

/** The current browser, read defensively: no navigator (prerender, tests) is not a bot. */
export function currentVisitorIsBot(): boolean {
  try {
    if (typeof navigator === 'undefined') return false;
    return isBotVisitor({ userAgent: navigator.userAgent, webdriver: (navigator as Navigator & { webdriver?: boolean }).webdriver });
  } catch {
    return false;
  }
}
